var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import s from './Customer.scss';
import get from 'lodash.get';
import isEqual from 'lodash.isequal';
import { Text, Layout, Cell, Box } from 'wix-style-react';
import { addressFormatter } from '@wix/crm-financial-formatters';
import { translate } from 'react-i18next';
import { WithCustomerLoader } from '../../loaders/loaders-builder';
import { isMobileView } from '../../../core';
var CustomerComponent = translate()(function (_a) {
    var t = _a.t, customer = _a.customer, newSubdivisionFormatEnabled = _a.newSubdivisionFormatEnabled;
    var email = get(customer, 'email.address');
    var companyName = get(customer, 'company.name');
    var name = get(customer, 'name');
    var phoneNumber = get(customer, 'phone.number');
    var vatId = get(customer, 'company.id');
    var billingAddress = get(customer, 'billingAddress', null);
    var shippingAddress = get(customer, 'shippingAddress', null);
    var addressLocalizedLocation = addressFormatter({
        t: t,
        newSubdivisionFormatEnabled: newSubdivisionFormatEnabled,
        street: get(customer, 'address.street', null),
        city: get(customer, 'address.city', null),
        state: get(customer, 'address.state', null),
        zip: get(customer, 'address.zip', null),
        country: get(customer, 'address.country', null),
    });
    var billingAddressLocalizedLocation = addressFormatter({
        t: t,
        newSubdivisionFormatEnabled: newSubdivisionFormatEnabled,
        street: get(customer, 'billingAddress.addressLine', null),
        addressLine2: get(customer, 'billingAddress.addressLine2', null),
        city: get(customer, 'billingAddress.city', null),
        state: get(customer, 'billingAddress.subdivision', null),
        zip: get(customer, 'billingAddress.postalCode', null),
        country: get(customer, 'billingAddress.country', null),
    });
    var shippingLocalizedAddress = addressFormatter({
        t: t,
        newSubdivisionFormatEnabled: newSubdivisionFormatEnabled,
        street: get(customer, 'shippingAddress.addressLine', null),
        addressLine2: get(customer, 'shippingAddress.addressLine2', null),
        city: get(customer, 'shippingAddress.city', null),
        state: get(customer, 'shippingAddress.subdivision', null),
        zip: get(customer, 'shippingAddress.postalCode', null),
        country: get(customer, 'shippingAddress.country', null),
    });
    var shouldDisplayShippingAddress = !!(shippingAddress &&
        shippingLocalizedAddress &&
        !isEqual(shippingAddress, billingAddress) &&
        !isEqual(shippingLocalizedAddress, addressLocalizedLocation));
    var shouldDisplayCustomerAddress = (billingAddressLocalizedLocation || addressLocalizedLocation) !== '';
    var CustomerInfoTitle = function (_a) {
        var children = _a.children, props = __rest(_a, ["children"]);
        return (React.createElement(Text, __assign({ size: "tiny", secondary: true, weight: "bold", light: true }, props), children));
    };
    var hasAddress = !!(shouldDisplayCustomerAddress || shouldDisplayShippingAddress);
    var customerInfoTitleText = hasAddress
        ? t('invoice-view:price-quote.view.customer.additional-info-title')
        : t('invoice-view:price-quote.view.customer.customer-info-title');
    var recipient = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Text, { size: "tiny", weight: "bold", secondary: true, dataHook: "customer-name" }, "".concat(name)),
            !!companyName && (React.createElement(Text, { size: "tiny", weight: "bold", secondary: true, dataHook: "company-name" }, companyName))));
    };
    var shippingAddressStyleMargin = function () {
        if (shouldDisplayCustomerAddress && !isMobileView()) {
            return '25px';
        }
        if (!shouldDisplayCustomerAddress) {
            return '0px';
        }
        if (shouldDisplayCustomerAddress && isMobileView()) {
            return '0px';
        }
    };
    var customerInfoMarginStyle = function () {
        if (isMobileView()) {
            return '0px';
        }
        if (shouldDisplayCustomerAddress && shouldDisplayShippingAddress) {
            return '48px';
        }
        if (hasAddress) {
            return '25px';
        }
        return '0px';
    };
    return (React.createElement("div", { className: s.customer, style: { paddingBottom: '35px' } },
        React.createElement(Layout, { alignItems: isMobileView() ? 'vertical' : 'horizontal' },
            shouldDisplayCustomerAddress && (React.createElement(Cell, { span: 4 },
                React.createElement(Box, { direction: "vertical", align: "left" },
                    React.createElement(CustomerInfoTitle, { dataHook: "billing-address-title" }, t('invoice-view:price-quote.view.customer.billing-address-title')),
                    recipient(),
                    React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, dataHook: "customer-billing-address" }, billingAddressLocalizedLocation || addressLocalizedLocation)))),
            shouldDisplayShippingAddress && (React.createElement(Cell, { span: 4 },
                React.createElement(Box, { marginLeft: shippingAddressStyleMargin(), direction: "vertical", marginTop: isMobileView() ? '10px' : undefined },
                    React.createElement(CustomerInfoTitle, null, !shouldDisplayCustomerAddress
                        ? t('invoice-view:price-quote.view.customer.billing-address-title')
                        : t('invoice-view:price-quote.view.customer.shipping-address-title')),
                    !shouldDisplayCustomerAddress && recipient(),
                    React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, dataHook: "customer-shipping-address" }, shippingLocalizedAddress)))),
            React.createElement(Cell, { span: 4 },
                React.createElement(Box, { direction: "vertical", marginLeft: customerInfoMarginStyle(), marginTop: isMobileView() ? '10px' : undefined },
                    React.createElement(CustomerInfoTitle, { dataHook: "customer-info-data-label" }, customerInfoTitleText),
                    !hasAddress && recipient(),
                    !!email && (React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, dataHook: "customer-email" }, email)),
                    !!phoneNumber && (React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, dataHook: "customer-phone-number" }, t('invoice-view:price-quote.view.customer.phone-title', {
                        phoneNumber: phoneNumber,
                    }))),
                    !!vatId && (React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, dataHook: "customer-vat-id" }, "".concat(t('invoice-view:quote.form.vat_id'), ": ").concat(vatId))))))));
});
export var Customer = WithCustomerLoader(translate(['invoice-view', 'locale-data'])(CustomerComponent));
//# sourceMappingURL=Customer.js.map